module.exports = __webpack_public_path__ + "static/media/ios-timer.c45debb5.svg";